import { core, indicator } from '@/api/api-endpoints'
import { PERMS } from '@/config/permissions'
import userFriendlyEr from '@/utils/userFriendlyEr'

export const typeTable = {
  TARGETS_TABLE: 1,
  BALANCE_TABLE: 2,
  OPERATOR_TABLE: 3,
}
export const ValueModel = (year) => {
  return {
    year: JSON.parse(JSON.stringify(year)),
    fact: null,
    plan: null,
  }
}
export const POSITION_IN_HEADER = {
  FIRST: '0',
  SECOND: '1',
}
export default {
  data: () => ({
    typeTable: 'TARGETS_TABLE',
    rows: null,
    tableHeaders: null,
  }),
  methods: {
    rebuildRows(skipRecalcOrder = false) {
      let rows = {}
      // generate headers by first row
      let tableHeaders = {}
      let data = this.data.data
      if (!data) {
        return false
      }
      if (skipRecalcOrder === false) {
        // sort by order, id
        data.sort((a, b) => {
          if (a.order > b.order) {
            return 1
          }
          if (a.order < b.order) {
            return -1
          }
          if (a.order === b.order) {
            if (a.id > b.id) {
              return 1
            }
            if (a.id < b.id) {
              return -1
            }
          }
          return 0
        })
        // update order
        let minOrder = 0
        data.forEach((currentVal, i) => {
          if (minOrder === 0 || data[i].order < minOrder) {
            minOrder = +data[i].order
          }
        })
        data.forEach((currentVal, i) => {
          const newOrder = minOrder + i
          if (data[i].order !== newOrder) {
            data[i].order = newOrder
            // if wrong save on server
            // this.updateOrder(data[i], newOrder)
          }
        })
      }
      // TODO: use skipedRows if perfomance problem
      // add missed values
      data.forEach((currentVal, i) => {
        data.forEach((comparedVal) => {
          let missedValues = []
          comparedVal.values.forEach((v) => {
            let yearExist = currentVal.values.findIndex(
              (s) => s.year === v.year
            )
            if (yearExist === -1) {
              missedValues.push(new ValueModel(v.year))
            }
          })
          // put to current
          missedValues.forEach((v) => {
            data[i].values.push(v)
          })
        })
      })
      data.forEach((v, index) => {
        // add number/doc, measure
        let id = index // this.getId(v, index)
        rows[id] = [
          {
            title: 'Номер',
            value: v.order,
            _headers: [
              {
                name: POSITION_IN_HEADER.FIRST,
                rowspan: 2,
                colspan: false,
              },
            ],
            width: 130,
            id: v.id,
            order: +v.order,
            name: v.name,
            measure: v.measure,
            source: v.source,
          },
          {
            title: 'Наименование',
            value: v.name,
            id: v.id,
            _headers: [
              {
                name: POSITION_IN_HEADER.FIRST,
                rowspan: 2,
                colspan: false,
              },
            ],
            _isEdit: false,
            width: 280,
            isDirectRequest: true,
            onChange() {
              this.name = this.value
            },
          },
          {
            title: 'Источник',
            value: v.source,
            id: v.id,
            _headers: [
              {
                name: POSITION_IN_HEADER.FIRST,
                rowspan: 2,
                colspan: false,
              },
            ],
            _isEdit: false,
            width: 130,
            isDirectRequest: true,
            onChange() {
              this.source = this.value
            },
          },
          {
            title: 'Единица измерения',
            value: v.measure?.name || 'шт.',
            _headers: [
              {
                name: POSITION_IN_HEADER.FIRST,
                rowspan: 2,
                colspan: false,
              },
            ],
            id: v.id,
            _isEdit: false,
            width: 100,
            isDirectRequest: true,
            type: 'select',
            options: this.$store.getters.readUrlEndpoint(
              this.getCollectionEndpoint()
            ).measure,
            onChange() {
              const measures = this.options
              const measure = measures.find((el) => {
                return el.name === this.value
              })
              this.measure_id = measure.id
              this.measure = measure
            },
          },
        ]

        if (this.hasDocumentField) {
          rows[id].push({
            title: 'Документ',
            value: v.document,
            _headers: [
              {
                name: POSITION_IN_HEADER.FIRST,
                rowspan: 2,
                colspan: false,
              },
            ],

            width: 100,
          })
        }
        // sort years
        v.values.sort((b, a) => {
          if (a.year > b.year) {
            return -1
          } else if (a.year < b.year) {
            return 1
          } else {
            return 0
          }
        })

        const planWidth = 80
        const factWidth = 80
        v.values.forEach((value) => {
          if (value.year && value.year > this.lastYear) {
            this.lastYear = +value.year
          }
          if (value.fact !== null) {
            value.fact = +value.fact
          }
          if (value.plan !== null) {
            value.plan = +value.plan
          }
          rows[id].push({
            _headers: [
              {
                name: POSITION_IN_HEADER.FIRST,
                rowspan: false,
                colspan: 2,
                title: +value.year,
                year: +value.year,
                width: planWidth + factWidth,
              },
              {
                name: POSITION_IN_HEADER.SECOND,
                rowspan: false,
                colspan: false,
                title: 'План',
                width: planWidth,
              },
            ],
            title: 'План',
            value: value.plan,
            _isPlan: true,
            year: value.year,
            id: v.id,
            _isEdit: false,
            _error: '',
            width: planWidth,
            pattern: /^(\d*((\.\d{0,2}))?(\d))$/i,
          })
          rows[id].push({
            _headers: [
              {
                name: POSITION_IN_HEADER.SECOND,
                rowspan: false,
                colspan: false,
                title: 'Факт',
                width: factWidth,
              },
            ],
            title: 'Факт',
            value: value.fact,
            _isFact: true,
            year: value.year,
            id: v.id,
            _isEdit: false,
            _error: '',
            width: factWidth,
            pattern: /^(\d*((\.\d{0,2}))?(\d))$/i,
          })
        })
      })

      for (let key in rows) {
        rows[key].forEach((v) => {
          v._headers.forEach((headerItem) => {
            if (!tableHeaders[headerItem.name]) {
              tableHeaders[headerItem.name] = []
            }
            tableHeaders[headerItem.name].push({
              colspan: headerItem.colspan,
              rowspan: headerItem.rowspan,
              value: headerItem.title || v.title,
              year: headerItem.year || 0,
              width: headerItem.width,
              columnEmpty: false,
            })
          })
        })
        break
      }

      this.rows = Object.assign({}, rows)
      this.tableHeaders = Object.assign({}, tableHeaders)

      this.checkEmptyColumn()
    },
    async getTableData() {
      this.data = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: indicator.objects({
            query: { type_table: typeTable[this.typeTable] },
          }),
        })
      ).data
    },
    scrollHandler($event) {
      let { scrollLeft = 0 } = $event.target
      this.$refs.tableHeader.style.marginLeft = `-${scrollLeft}px`
    },
    checkEmptyColumn() {
      let notEmptyYears = []
      // check all value and collect not empty
      for (let rowKey in this.rows) {
        let row = this.rows[rowKey]
        row.forEach((col) => {
          if (col.value !== null) {
            notEmptyYears.push(col.year)
          }
        })
      }
      // check headers and set empty
      let headerRow
      headerRow = this.tableHeaders[POSITION_IN_HEADER.FIRST] || []

      headerRow.forEach((headerCol, headerIndex) => {
        if (headerCol.year) {
          this.tableHeaders[POSITION_IN_HEADER.FIRST][
            headerIndex
          ].columnEmpty = true
        }
      })
    },
    deleteEmptyColumn(year) {
      this.$e
        .confirmBox(
          'Колонка будет удалена, если в ней не были заданы значения',
          'Удалить колонку?'
        )
        .then(() => {
          this.$bar.start()
          this.$store
            .dispatch('deleteModel', {
              url: this.getDeleteEmptyColumnUrl(year),
              data: {},
              endpoint: this.getEndpoint(this.$route),
            })
            .then(() => {
              this.$e.successBox('Запись удалена')
              this.fetchData()
            })
            .catch((erResponse) => {
              this.$bar.finish()
              console.error(erResponse)
              this.$e.errorBox(erResponse)
            })
        })
    },
    checkRow(id) {
      if (this.checkedRows.includes(id)) {
        this.checkedRows = this.checkedRows.filter((item) => item !== id)
      } else {
        this.checkedRows.push(id)
      }
    },
    createEmptyYearCol(year) {
      const type = typeTable[this.typeTable]
      this.$store.dispatch('createModel', {
        url: this.objectEmptyTableTypeYear(year, type),
        data: {},
      })
    },
    addNewCol(params) {
      if (!params) {
        return
      }

      let newCol = new ValueModel(this.year)

      let needInsert = true

      this.data.data[0].values.forEach((col) => {
        if (col.year == this.year) {
          needInsert = false
        }
      })

      if (!needInsert) {
        return false
      }

      this.data.data[0].values.push(newCol)

      this.data.data[0].values.sort(function (a, b) {
        return parseFloat(a.year) - parseFloat(b.year)
      })
      this.rebuildRows()
      this.createEmptyYearCol(this.year)
      this.$nextTick(() => {
        this.moveTableToLeft()
      })
    },
    moveTableToLeft() {
      if (this.$refs.tablePS) {
        this.$refs.tablePS.setScrollLeft(9999999)
      }
    },
    saveEdit(item) {
      if (item.value) {
        item.value = item.value.toString().replace(/,/, '.')
        item.value = item.value.toString().replace(/,/g, '')
      }
      let doublePattern = item.pattern
      if (doublePattern && !doublePattern.test(item.value)) {
        item._error = 'Введите число'
        return false
      }
      item._isEdit = false

      if (item._isPlan) {
        item.plan = +item.value
      } else {
        item.fact = +item.value
      }
      item._error = null
      let url = this.getObjectPlanFactUpdateUrl(item.id, item.year)
      if (item.isDirectRequest) {
        url = indicator.objectUpdateById(item.id)
        item.onChange(item)
      }
      this.$store
        .dispatch('updateModel', {
          url,
          endpoint: null,
          data: item,
        })
        .then((r) => {
          if (r.id) {
            item.id = r.id
          }
          this.getTableData().then(() => {
            this.rebuildRows()
          })
        })
        .catch((e) => {
          item._isEdit = true
          item._error = userFriendlyEr.recognize(e)
        })
    },

    setEdit(item, colIndex) {
      let count = 1
      if (colIndex < count) {
        return
      }
      if (this.userHavePermissionEx(PERMS.EDIT) === true) {
        item._isEdit = true
      }
    },
    mobileSetEdit(item, colIndex) {
      let count = 1
      if (colIndex < count) {
        return
      }
      if (this.userHavePermissionEx(PERMS.EDIT) === true && this.$isMobile()) {
        item._isEdit = true
      }
    },
    getCollectionEndpoint() {
      return core.collection('measure', {
        query: {
          type: 'indicator',
        },
      })
    },
    async getCollection() {
      await this.$store.dispatch('updateUrlEndpoint', {
        endpoint: this.getCollectionEndpoint(),
        fromCache: true,
      })
    },
  },
}
